@if (simpleTestingGroup) {
    <div [formGroup]="simpleTestingGroup">
        <div class="form-group">
            <label for="catalogueSelect">
                {{ 'simpleTestingTestPlan.catalogueLabel' | t: { required: type == SimpleTestingType.DesignImplementation ? '*' : '' } }}
            </label>
            <ng-select
                id="catalogueSelect"
                name="catalogueSelect"
                [items]="standingData.Catalogues"
                (change)="catalogueChanged.emit($event)"
                formControlName="Catalogue"
                bindLabel="Name"
                bindValue="ID"
                [placeholder]="type == SimpleTestingType.DesignImplementation ? 'Required' : ''"
            >
            </ng-select>
        </div>
        <div class="form-group-separator"></div>

        <div class="row">
            <div class="col-12 col-xl-6 left-block">
                <div class="row">
                    <div class="form-group col-6">
                        <label for="testersSelect">{{ 'simpleTestingTestPlan.testersLabel' | t }}</label>
                        <ng-select
                            id="testersSelect"
                            name="testersSelect"
                            [items]="standingData.Testers"
                            formControlName="Testers"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [placeholder]="'simpleTestingTestPlan.requiredPlaceholder' | t"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="evidenceUploadersSelect">{{ 'simpleTestingTestPlan.evidenceUploadersLabel' | t }}</label>
                        <ng-select
                            id="evidenceUploadersSelect"
                            name="evidenceUploadersSelect"
                            [items]="standingData.EvidenceUploaders"
                            formControlName="EvidenceUploaders"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [placeholder]="'simpleTestingTestPlan.requiredPlaceholder' | t"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <label>{{ 'simpleTestingTestPlan.initialTestDateLabel' | t }}</label>
                        <date-input formControlName="InitialTestDate"></date-input>
                    </div>
                    <div class="form-group col-6">
                        <label for="uploaderDueDateInput"
                            >{{ 'simpleTestingTestPlan.uploaderDueDateLabel' | t }}
                            <i
                                class="far fa-question-circle ms-2"
                                [matTooltip]="'simpleTestingTestPlan.uploaderDueDateTooltip' | t"
                            ></i>
                        </label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            id="uploaderDueDateInput"
                            name="uploaderDueDateInput"
                            formControlName="UploaderDueDate"
                        />
                        @if (simpleTestingGroup.controls.UploaderDueDate.errors) {
                            <div class="red">
                                @if (simpleTestingGroup.controls.UploaderDueDate.errors.min) {
                                    <p>{{ 'simpleTestingTestPlan.cannotBeNegative' | t }}</p>
                                }
                            </div>
                        }
                    </div>
                </div>

                <div class="form-group-separator"></div>

                <div class="row">
                    <div class="form-group col-6">
                        <label for="linkedStandardSelect">{{ 'simpleTestingTestPlan.linkedStandardLabel' | t }}</label>
                        <ng-select
                            id="linkedStandardSelect"
                            name="linkedStandardSelect"
                            [items]="standingData.LinkedStandards"
                            formControlName="LinkedStandard"
                            bindLabel="Name"
                            bindValue="ID"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="testSamplesInput">{{ 'simpleTestingTestPlan.testSamplesLabel' | t }}</label>
                        <input
                            type="number"
                            class="form-control form-control-sm"
                            id="testSamplesInput"
                            name="testSamplesInput"
                            formControlName="TestSamples"
                        />
                        @if (simpleTestingGroup.controls.TestSamples.errors) {
                            <div class="red">
                                @if (simpleTestingGroup.controls.TestSamples.errors.min) {
                                    <p>{{ 'simpleTestingTestPlan.cannotBeNegative' | t }}</p>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <label for="qualityAspectSelect">{{ 'simpleTestingTestPlan.qualityAspectLabel' | t }}</label>
                        <ng-select
                            id="qualityAspectSelect"
                            name="qualityAspectSelect"
                            [items]="standingData.QualityAspects"
                            formControlName="QualityAspect"
                            bindLabel="Name"
                            bindValue="ID"
                            [multiple]="true"
                            [closeOnSelect]="false"
                        >
                        </ng-select>
                    </div>
                    <div class="form-group col-6">
                        <label for="testFrequencySelect">{{ 'simpleTestingTestPlan.testFrequencyLabel' | t }}</label>
                        <ng-select
                            id="testFrequencySelect"
                            name="testFrequencySelect"
                            [items]="standingData.TestFrequencies"
                            formControlName="TestFrequency"
                            bindLabel="Name"
                            bindValue="ID"
                        >
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-6 right-block">
                <div class="row">
                    <div class="form-group col">
                        <cerrix-textarea
                            [fieldLabel]="'simpleTestingTestPlan.testActivityLabel' | t"
                            identifier="testActivityInput"
                            [rows]="7"
                            formControlName="TestActivity"
                        ></cerrix-textarea>
                    </div>
                </div>
                <div class="form-group-separator"></div>
                <div class="row">
                    <div class="form-group col">
                        <cerrix-textarea
                            [fieldLabel]="'simpleTestingTestPlan.testNormLabel' | t"
                            identifier="testNormInput"
                            [rows]="7"
                            formControlName="TestNorm"
                        ></cerrix-textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
